<template>
  <div :class="cssValue">
    <slot v-if="showChildComponent"></slot>
    <div v-else-if="showError" class="insufficientPermissionBox">
      <p>
        Nimate pravice za ogled vsebine.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PermissionComponent',
  props: {
    permissionId: {
      type: String,
      default: null
    },
    parameterKey: {
      type: String,
      default: null
    },
    parameterValue: {
      type: String | Number,
      default: null
    },
    additionalDataRequired: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: false
    },
    cssClass: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      showChildComponent: false
    }
  },
  computed: {
    cssValue () {
      if (this.showChildComponent) {
        return this.cssClass
      }
      return ''
    }
  },
  mounted () {
    this.checkPermission()
  },
  methods: {
    checkPermission () {
      if (this.permissionId !== null) {
        this.showChildComponent = this.HasPermission(this.permissionId, this.additionalDataRequired, this.parameterKey, this.parameterValue)
      }
    }
  },
  watch: {
    permissionId: function () {
      this.checkPermission()
    },
    parameterKey: function () {
      this.checkPermission()
    },
    parameterValue: function () {
      this.checkPermission()
    }
  }
}
</script>

<style scoped src="../../../../../static/css/PermissionComponent.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/GlobalneKomponente/PermissionComponent.vue